import { Component, Input, OnInit, OnDestroy , ViewChild, ElementRef } from '@angular/core';
import { Output, EventEmitter } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';
import { RelinkCallComponent } from 'src/app/Shared/relink-call/relink-call.component'
import { IStoreNameChange } from '../../Shared/interface2';
import { Subject } from 'rxjs';
import { CalltrackerService } from 'src/app/services/operations/calltracker.service';
import { StoreService } from 'src/app/services/stores.service';
import { NotificationService } from 'src/app/services/operations/notification.service';
import { ToastrService } from 'ngx-toastr';
import { AppService } from 'src/app/services/app.service';
import { CallTypeEnum } from 'src/app/Shared/enum';

@Component({
  selector: 'app-phonecall-bar',
  templateUrl: './phonecall-bar.component.html',
  styleUrls: ['./phonecall-bar.component.scss'],
  standalone: false
})
export class PhonecallBarComponent implements OnInit, OnDestroy {
  private baseURL = this.appService.config.apiBaseUrl;
  public loaderIcon: Promise<boolean>;
  public callTypeEnum = CallTypeEnum;
  callnotificationSub: any;
  private storeSub: any;
  @Input() isAdmin: boolean;
  @Input() isCallCenterAgent: boolean;
  @Output() phonePopup = new EventEmitter<void>();
  @Output() initiateDelNotif = new EventEmitter<number>();
  @Output() phoneToggleClosed = new EventEmitter<void>();
  @Input() lastAccessedFacility: number;
  @Input() toasterConfig: Object;
  @Input() AdminOrOps: string;
  @Input() storeNameChange: Subject<IStoreNameChange>;
  @ViewChild('callBody') callBody: ElementRef<HTMLElement>;
  activeTab: number | 'all' = 'all';
  notifications: any[] = [];
  filteredNotifications: any[] = [];
  selectedPhoneId: number;
  isPopupOpen = false;
  counts = {
    all: 0,
    missed: 0,
    inbound: 0,
    voicemail: 0
  };
  isLoading = false;
  getcallNotificationCountObj

  constructor(
    private calltrackerService: CalltrackerService,
    private storeService: StoreService,
    private toastr: ToastrService,
    private notificationService: NotificationService,
    private appService: AppService,
    private modalWrapper: ModalWrapperService,
  ) { }

  ngOnInit(): void {
    this.callNotificationHub(this.lastAccessedFacility);
    this.storeSub = this.storeNameChange.subscribe(val => {
      const lastAccessedFacility = val.Id;
      if (!lastAccessedFacility) {
        return;
      }
      this.lastAccessedFacility = lastAccessedFacility;
      this.notifications = [];
      this.filteredNotifications = [];
      this.callNotificationHub(lastAccessedFacility);
    });
  }
  openPopup(): void {
    this.activeTab = 'all';
    this.isPopupOpen = true;
    this.loadNotifications(true);
  }
  filterNotifications(): void {
    if (this.activeTab === 'all') {
      this.filteredNotifications = this.notifications;
      return;
    }

    this.filteredNotifications = this.notifications.filter(
      x => x.CallType === this.activeTab
    );
  }
  getCallTypeClass(callType: number): string {
    switch (callType) {
      case CallTypeEnum.Missed:
        return 'missed';

      case CallTypeEnum.Voicemail:
        return 'voicemail';

      case CallTypeEnum.Inbound:
        return 'inbound';

      default:
        return '';
    }
  }
  callNotificationHub(facilityId: number): void {
    if (!this.notificationService.isConnectedTo(facilityId)) {
      this.notificationService.stopConnection();
      this.notificationService.startConnection(this.baseURL, facilityId);
    }
    this.callnotificationSub = this.notificationService.callNotificationCount$
      .subscribe((response: any) => {
        if (!response) {
          return;
        }
        this.counts = {
          missed: response.Missed,
          inbound: response.Inbound,
          voicemail: response.Voicemail,
          all: response.Total,
        };
      });
  }
  formatPhoneNumber(phone: string): string {
    if (!phone) return '';
    const cleaned = phone.replace(/\D/g, '');
    if (cleaned.length !== 10) return phone;
    const area = cleaned.substring(0, 3);
    const central = cleaned.substring(3, 6);
    const line = cleaned.substring(6);
    return `(${area}) ${central}-${line}`;
  }
  getTimeDisplay(time: string): string {
    if (!time) {
      return '';
    }
    const callTime = new Date(time);
    const now = new Date();
    const diffMs = now.getTime() - callTime.getTime();
    const diffMinutes = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMinutes / 60);
    // Less than 5 mins
    if (diffMinutes < 5) {
      return 'Just now';
    }
    // Less than 1 hour
    if (diffMinutes < 60) {
      return `${diffMinutes} min ago`;
    }
    // Less than 24 hours
    if (diffHours < 24) {
      const remainingMinutes = diffMinutes % 60;
      if (remainingMinutes === 0) {
        return `${diffHours} hour${diffHours > 1 ? 's' : ''} ago`;
      }
      return `${diffHours} hour${diffHours > 1 ? 's' : ''} ${remainingMinutes} min ago`;
    }
    // More than 24 hours
    const month = String(callTime.getMonth() + 1).padStart(2, '0');
    const day = String(callTime.getDate()).padStart(2, '0');
    const year = callTime.getFullYear();
    const hours = String(callTime.getHours()).padStart(2, '0');
    const minutes = String(callTime.getMinutes()).padStart(2, '0');
    return `${month}/${day}/${year} ${hours}:${minutes}`;
  }
  openRelinkPopup(call: any): void {
    this.loaderIcon = Promise.resolve(true);
    this.calltrackerService.GetPhonecall(call.PhoneId.toString())
      .subscribe({
        next: (callDetails) => {
          this.storeService.getStores().subscribe({
            next: (stores) => {
              this.loaderIcon = Promise.resolve(false);

              const modalRef: BsModalRef = this.modalWrapper.openComponent(
                RelinkCallComponent,
                {
                  initialState: {
                    callData: {
                      ...callDetails,
                      CallerID: callDetails.PhoneNumber,
                      parentModal: null
                    },
                    allStores: stores
                  },
                  class: 'modal-xl modal-dialog-centered',
                  backdrop: 'static',
                  keyboard: false
                }
              );
              modalRef.content.onRelinkSuccess.subscribe((result) => {
                this.openPopup();

                if (result?.success) {
                  this.toastr.success('Relink call was successful', 'Success', this.toasterConfig);
                } else {
                  this.toastr.error('Failed to relink call', 'Failure', this.toasterConfig);
                }
              });
            },
            error: () => {
              this.loaderIcon = Promise.resolve(false);
            }
          });
        },
        error: () => {
          this.loaderIcon = Promise.resolve(false);
          this.toastr.error('Failed to load call details');
        }
      });
  }
  cancel(): void {
    this.isPopupOpen = false;
    this.phoneToggleClosed.emit();
  }
  confirmDelete(phoneId: number): void {
    this.initiateDelNotif.emit(phoneId);
  }
  loadNotifications(reset: boolean = false): void {
    if (reset) {
      this.notifications = [];
    }
    if (this.isLoading) {
      return;
    }
    this.isLoading = true;
    const input = {
      facilityId: this.lastAccessedFacility,
      pageModel: null
    };
    this.calltrackerService.getCallNotifications(input).subscribe({
      next: (response: any[]) => {
        if (!response || response.length === 0) {
          this.filterNotifications();
          this.isLoading = false;
          return;
        }
        this.notifications = response;
        this.filterNotifications();

        setTimeout(() => {
          if (this.callBody) {
            this.callBody.nativeElement.scrollTop = 0;
          }
        });
        this.isLoading = false;
      },
      error: () => {
        this.isLoading = false;
      }
    });
  }
  setActiveTab(tab: number | 'all'): void {
    this.activeTab = tab;
    this.filterNotifications();
    setTimeout(() => {
      if (this.callBody) {
        this.callBody.nativeElement.scrollTop = 0;
      }
    });
  }
  ngOnDestroy() {
    if (this.callnotificationSub) {
      this.callnotificationSub.unsubscribe();
    }
    if (this.storeSub) {
      this.storeSub.unsubscribe();
    }
  }
}
